/**
 * TrustAccountWidget — Resident trust account for subject dashboard (DRR-321)
 *
 * Shows the subject's personal trust account balance.
 * Required by 144G regulations for facilities managing resident funds.
 * Currently shows placeholder until ERP integration is complete.
 */

import React from 'react';
import {
  Stack,
  Text,
  Group,
  Alert,
  Paper,
  Box,
  ThemeIcon,
} from '@mantine/core';
import { IconPigMoney } from '@tabler/icons-react';
import type { WidgetProps } from '@ferp/core';

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function TrustAccountWidget(_props: WidgetProps) {
  // Trust account data comes from ERP subgraph - show placeholder until integrated
  return (
    <Stack gap="sm">
      <Group gap="xs">
        <IconPigMoney size={16} color="var(--mantine-color-green-6)" />
        <Text fw={600} size="sm">Trust Account</Text>
      </Group>

      <Paper withBorder p="sm" radius="sm">
        <Group justify="space-between" wrap="nowrap">
          <Box>
            <Text size="xs" c="dimmed">Available Balance</Text>
            <Text fw={700} size="xl" c="green">
              {formatCurrency(0)}
            </Text>
          </Box>
          <ThemeIcon size="lg" variant="light" color="green">
            <IconPigMoney size={20} />
          </ThemeIcon>
        </Group>
      </Paper>

      <Alert icon={<IconPigMoney size={16} />} color="blue" variant="light">
        Trust account available via ERP integration.
      </Alert>
    </Stack>
  );
}
